(() => {
  if (window.__AYV2Loaded) return;
  window.__AYV2Loaded = true;

  const uiLocale = (document.documentElement.lang || 'en').split('-')[0];
  const uiTranslations = {"de": {"This action is not available.": "Diese Aktion ist nicht verfügbar.", "Lace and knots close-up": "Lace und Knüpfstellen aus der Nähe", "This product is not available for quick shopping.": "Für dieses Produkt ist die Schnellansicht nicht verfügbar.", "The product details could not be verified. Please open the product page.": "Die Produktdetails konnten nicht geladen werden. Bitte öffne die Produktseite.", "Choose available options": "Wähle verfügbare Optionen", "In stock — ready to add.": "Auf Lager – bereit für deinen Warenkorb.", "This option is sold out.": "Diese Variante ist ausverkauft.", "Choose an available combination.": "Wähle eine verfügbare Kombination.", "ADD TO CART": "IN DEN WARENKORB", "SOLD OUT": "AUSVERKAUFT", "Loading options…": "Optionen werden geladen …", "This product is currently unavailable.": "Dieses Produkt ist derzeit nicht verfügbar.", "NOT AVAILABLE": "NICHT VERFÜGBAR", "The product details did not match the selected item.": "Die Produktdetails passen nicht zum ausgewählten Artikel.", "Options could not be loaded. Open the full product page to continue.": "Die Optionen konnten nicht geladen werden. Öffne die Produktseite, um fortzufahren.", "Please try again or view the product details.": "Bitte versuche es erneut oder öffne die Produktdetails.", "Adding your selection…": "Deine Auswahl wird hinzugefügt …", "This item could not be added.": "Dieser Artikel konnte nicht hinzugefügt werden.", "Added to your bag.": "Zu deinem Warenkorb hinzugefügt.", "ADDED TO YOUR BAG": "IM WARENKORB", "Product information": "Produktinformationen", "Product detail": "Produktdetail", "More information is available in this section.": "Weitere Informationen findest du in diesem Abschnitt.", "In Stock": "Auf Lager", "Out of Stock": "Nicht auf Lager", "BUY NOW": "JETZT KAUFEN", "Selected option": "Ausgewählte Option", "This option combination is unavailable. Please choose another option.": "Diese Kombination ist nicht verfügbar. Bitte wähle eine andere Option.", "This selection is currently sold out.": "Diese Auswahl ist derzeit ausverkauft.", "Please choose an available option combination.": "Bitte wähle eine verfügbare Kombination.", "Please choose an available option before checking out.": "Bitte wähle eine verfügbare Option, bevor du zur Kasse gehst.", "Unable to add this item.": "Dieser Artikel konnte nicht hinzugefügt werden.", "Unable to add this item. Please try again.": "Dieser Artikel konnte nicht hinzugefügt werden. Bitte versuche es erneut.", "Reviews could not be loaded. Please refresh the page to try again.": "Die Bewertungen konnten nicht geladen werden. Bitte lade die Seite neu.", "Loading customer reviews…": "Kundenbewertungen werden geladen …", "UNAVAILABLE": "NICHT VERFÜGBAR", "ADDING…": "WIRD HINZUGEFÜGT …", "LOADING…": "WIRD GELADEN …", "Length": "Länge", "Cap Size": "Kappengröße", "Lace Tone": "Lace-Farbton"}, "es": {"This action is not available.": "Esta acción no está disponible.", "Lace and knots close-up": "Detalle del tul y los nudos", "This product is not available for quick shopping.": "La compra rápida no está disponible para este producto.", "The product details could not be verified. Please open the product page.": "No se han podido cargar los detalles del producto. Abre la página del producto.", "Choose available options": "Elige las opciones disponibles", "In stock — ready to add.": "En stock: listo para añadir.", "This option is sold out.": "Esta opción está agotada.", "Choose an available combination.": "Elige una combinación disponible.", "ADD TO CART": "AÑADIR A LA CESTA", "SOLD OUT": "AGOTADO", "Loading options…": "Cargando opciones…", "This product is currently unavailable.": "Este producto no está disponible actualmente.", "NOT AVAILABLE": "NO DISPONIBLE", "The product details did not match the selected item.": "Los detalles del producto no coinciden con el artículo seleccionado.", "Options could not be loaded. Open the full product page to continue.": "No se han podido cargar las opciones. Abre la página del producto para continuar.", "Please try again or view the product details.": "Inténtalo de nuevo o consulta los detalles del producto.", "Adding your selection…": "Añadiendo tu selección…", "This item could not be added.": "No se ha podido añadir este artículo.", "Added to your bag.": "Añadido a tu cesta.", "ADDED TO YOUR BAG": "AÑADIDO A TU CESTA", "Product information": "Información del producto", "Product detail": "Detalle del producto", "More information is available in this section.": "Encontrarás más información en esta sección.", "In Stock": "En stock", "Out of Stock": "Sin stock", "BUY NOW": "COMPRAR AHORA", "Selected option": "Opción seleccionada", "This option combination is unavailable. Please choose another option.": "Esta combinación no está disponible. Elige otra opción.", "This selection is currently sold out.": "Esta selección está agotada actualmente.", "Please choose an available option combination.": "Elige una combinación de opciones disponible.", "Please choose an available option before checking out.": "Elige una opción disponible antes de finalizar la compra.", "Unable to add this item.": "No se ha podido añadir este artículo.", "Unable to add this item. Please try again.": "No se ha podido añadir este artículo. Inténtalo de nuevo.", "Reviews could not be loaded. Please refresh the page to try again.": "No se han podido cargar las reseñas. Actualiza la página e inténtalo de nuevo.", "Loading customer reviews…": "Cargando reseñas de clientes…", "UNAVAILABLE": "NO DISPONIBLE", "ADDING…": "AÑADIENDO…", "LOADING…": "CARGANDO…", "Length": "Largo", "Cap Size": "Talla del gorro", "Lace Tone": "Tono del tul"}};
  const uiText = (value) => uiTranslations[uiLocale]?.[value] || value;
  const uiOption = (name, value) => {
    if (!['de', 'es'].includes(uiLocale)) return value;
    const label = String(name).toLowerCase();
    if (label.includes('length')) return String(value).replace(/\s*(inches|inch|in)\b/gi, uiLocale === 'de' ? ' Zoll' : ' pulgadas');
    const words = uiLocale === 'de' ? {Small:'Klein',Medium:'Mittel',Large:'Groß',Light:'Hell',Brown:'Braun',Dark:'Dunkel',Deep:'Dunkel',Transparent:'Transparent'} : {Small:'Pequeña',Medium:'Mediana',Large:'Grande',Light:'Claro',Brown:'Marrón',Dark:'Oscuro',Deep:'Oscuro',Transparent:'Transparente'};
    return String(value).replace(/\b(Small|Medium|Large|Light|Brown|Dark|Deep|Transparent)\b/g, (word) => uiLocale === 'es' && /lace/i.test(name) && word === 'Medium' ? 'Medio' : words[word]);
  };


  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn();

  ready(() => {
    document.documentElement.classList.add('ayv2-motion');

    const refreshCartCount = async () => {
      const countNodes = [...document.querySelectorAll('[data-ayv2-cart-count]')];
      if (!countNodes.length) return;
      try {
        const response = await fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;
        const cartState = await response.json();
        countNodes.forEach((node) => { node.textContent = String(cartState.item_count || 0); });
      } catch (_) {
        // The server-rendered count remains valid when a refresh is unavailable.
      }
    };
    document.addEventListener('ayv2:cart-updated', refreshCartCount);

    const createTrackGallery = ({
      surface,
      viewport,
      track,
      getCount,
      getIndex,
      onSettled,
      navigationSelector
    }) => {
      if (!surface || !viewport || !track) return null;

      let position = Number(getIndex?.()) || 0;
      let targetIndex = null;
      let settleTimer = 0;
      let settleHandler = null;
      let settleToken = 0;
      let gesture = null;

      const count = () => Math.max(0, Number(getCount?.()) || 0);
      const clamp = (value) => Math.max(0, Math.min(Math.max(0, count() - 1), Number(value) || 0));
      const prefersReducedMotion = () => Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);

      const renderPosition = (nextPosition, duration = 0) => {
        if (!count()) return;
        position = clamp(nextPosition);
        const width = Math.max(1, viewport.clientWidth);
        track.style.transition = duration > 0 && !prefersReducedMotion()
          ? `transform ${duration}ms cubic-bezier(.22,.72,.22,1)`
          : 'none';
        track.style.transform = `translate3d(${-position * width}px,0,0)`;
      };

      const renderedPosition = () => {
        if (!count()) return 0;
        const transform = window.getComputedStyle(track).transform;
        let translateX = 0;
        if (transform && transform !== 'none') {
          const values = transform
            .slice(transform.indexOf('(') + 1, transform.lastIndexOf(')'))
            .split(',')
            .map(Number);
          translateX = transform.startsWith('matrix3d') ? (values[12] || 0) : (values[4] || 0);
        }
        return clamp(-translateX / Math.max(1, viewport.clientWidth));
      };

      const cancelSettle = ({ freeze = false } = {}) => {
        const frozenPosition = freeze ? renderedPosition() : position;
        if (settleTimer) window.clearTimeout(settleTimer);
        if (settleHandler) track.removeEventListener('transitionend', settleHandler);
        settleTimer = 0;
        settleHandler = null;
        settleToken += 1;
        targetIndex = null;
        track.style.transition = 'none';
        if (freeze && count()) renderPosition(frozenPosition);
        return frozenPosition;
      };

      const clearGesture = () => {
        if (gesture?.frame) window.cancelAnimationFrame(gesture.frame);
        gesture = null;
        surface.classList.remove('is-swipe-dragging');
      };

      const settle = (nextIndex, { immediate = false, meta = {} } = {}) => {
        const total = count();
        if (!total) return;
        const index = Math.max(0, Math.min(total - 1, Math.round(nextIndex)));
        const currentPosition = cancelSettle({ freeze: true });
        const remaining = Math.abs(index - currentPosition);
        const duration = immediate || prefersReducedMotion() || remaining < .001
          ? 0
          : Math.round(220 + Math.min(1, remaining) * 100);
        targetIndex = index;
        const token = settleToken;

        const finish = () => {
          if (token !== settleToken) return;
          if (settleTimer) window.clearTimeout(settleTimer);
          if (settleHandler) track.removeEventListener('transitionend', settleHandler);
          settleTimer = 0;
          settleHandler = null;
          targetIndex = null;
          renderPosition(index);
          onSettled?.(index, meta);
        };

        if (!duration) {
          renderPosition(index);
          finish();
          return;
        }

        settleHandler = (event) => {
          if (event.target === track && event.propertyName === 'transform') finish();
        };
        track.addEventListener('transitionend', settleHandler);
        settleTimer = window.setTimeout(finish, duration + 80);
        renderPosition(index, duration);
      };

      const select = (nextIndex, { animate = true, meta = {} } = {}) => {
        const total = count();
        if (!total) return;
        clearGesture();
        const normalized = (Number(nextIndex) + total) % total;
        settle(normalized, { immediate: !animate, meta });
      };

      const step = (direction, options = {}) => {
        const total = count();
        if (!total) return;
        const current = Number.isInteger(targetIndex) ? targetIndex : Math.round(Number(getIndex?.()) || 0);
        select(current + direction, options);
      };

      const addSample = (x) => {
        if (!gesture) return;
        const now = performance.now();
        gesture.samples.push({ x, time: now });
        const cutoff = now - 110;
        while (gesture.samples.length > 2 && gesture.samples[0].time < cutoff) gesture.samples.shift();
      };

      const velocity = () => {
        if (!gesture || gesture.samples.length < 2) return 0;
        const first = gesture.samples[0];
        const last = gesture.samples[gesture.samples.length - 1];
        return (last.x - first.x) / Math.max(1, last.time - first.time);
      };

      const resolveAxis = ({ final = false } = {}) => {
        if (!gesture || gesture.axis) return gesture?.axis || null;
        const absX = Math.abs(gesture.deltaX);
        const absY = Math.abs(gesture.deltaY);
        const horizontalDistance = final ? 3 : 4;
        const horizontalRatio = final ? .85 : 1.05;
        if (absX >= horizontalDistance && absX > absY * horizontalRatio) gesture.axis = 'x';
        else if (absY >= 8 && absY > absX * 1.25) gesture.axis = 'y';
        return gesture.axis;
      };

      const renderDrag = () => {
        if (!gesture) return;
        if (gesture.frame) window.cancelAnimationFrame(gesture.frame);
        gesture.frame = window.requestAnimationFrame(() => {
          if (!gesture) return;
          gesture.frame = 0;
          renderPosition(gesture.basePosition - gesture.deltaX / gesture.width);
        });
      };

      const finishDrag = (event, { cancelled = false } = {}) => {
        if (!gesture) return;
        const completedGesture = gesture;
        if (completedGesture.frame) window.cancelAnimationFrame(completedGesture.frame);
        if (event && Number.isFinite(event.clientX)) {
          completedGesture.deltaX = event.clientX - completedGesture.startX;
          addSample(event.clientX);
        }
        let nextIndex = completedGesture.anchorIndex;
        if (resolveAxis({ final: true }) === 'x') {
          renderPosition(completedGesture.basePosition - completedGesture.deltaX / completedGesture.width);
          const distance = Math.abs(completedGesture.deltaX);
          const distanceRatio = distance / completedGesture.width;
          const duration = Math.max(1, performance.now() - completedGesture.startedAt);
          const flickVelocity = velocity();
          const direction = completedGesture.deltaX < 0 ? 1 : -1;
          const lightSwipe = distance >= 6 && duration <= 650;
          const fastFlick = distance >= 4
            && Math.abs(flickVelocity) >= .08
            && Math.sign(flickVelocity) === Math.sign(completedGesture.deltaX);
          const longDrag = distanceRatio >= .12;
          const candidate = completedGesture.anchorIndex + direction;
          if (!cancelled && (lightSwipe || fastFlick || longDrag) && candidate >= 0 && candidate < count()) {
            nextIndex = candidate;
          }
        }
        clearGesture();
        try {
          if (surface.hasPointerCapture(completedGesture.id)) surface.releasePointerCapture(completedGesture.id);
        } catch (_) {}
        settle(nextIndex, { meta: { scroll: true } });
      };

      surface.addEventListener('pointerdown', (event) => {
        if (navigationSelector && event.target.closest(navigationSelector)) return;
        if (event.button !== undefined && event.button !== 0) return;
        if (event.pointerType === 'mouse' && !window.matchMedia('(max-width: 749px)').matches) return;
        if (count() < 2) return;
        const basePosition = cancelSettle({ freeze: true });
        clearGesture();
        renderPosition(basePosition);
        const now = performance.now();
        gesture = {
          id: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          deltaX: 0,
          deltaY: 0,
          axis: null,
          basePosition,
          anchorIndex: Math.max(0, Math.min(count() - 1, Math.round(basePosition))),
          width: Math.max(1, viewport.clientWidth),
          frame: 0,
          startedAt: now,
          samples: [{ x: event.clientX, time: now }]
        };
        try { surface.setPointerCapture(event.pointerId); } catch (_) {}
      });

      surface.addEventListener('pointermove', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        gesture.deltaX = event.clientX - gesture.startX;
        gesture.deltaY = event.clientY - gesture.startY;
        resolveAxis({ final: true });
        if (gesture.axis !== 'x') return;
        if (event.cancelable) event.preventDefault();
        surface.classList.add('is-swipe-dragging');
        addSample(event.clientX);
        renderDrag();
      });

      surface.addEventListener('pointerup', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        gesture.deltaX = event.clientX - gesture.startX;
        gesture.deltaY = event.clientY - gesture.startY;
        resolveAxis();
        finishDrag(event);
      });

      surface.addEventListener('pointercancel', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const horizontal = resolveAxis({ final: true }) === 'x';
        finishDrag(null, { cancelled: !horizontal });
      });

      surface.addEventListener('lostpointercapture', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const horizontal = resolveAxis({ final: true }) === 'x';
        finishDrag(null, { cancelled: !horizontal });
      });

      surface.addEventListener('keydown', (event) => {
        if (count() < 2 || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        step(event.key === 'ArrowRight' ? 1 : -1, { meta: { scroll: true } });
      });

      const reset = (index = 0, { notify = true, meta = {} } = {}) => {
        clearGesture();
        cancelSettle();
        if (!count()) return;
        const nextIndex = clamp(index);
        renderPosition(nextIndex);
        if (notify) onSettled?.(nextIndex, meta);
      };

      const refresh = () => {
        if (!count()) return;
        const nextIndex = Number.isInteger(targetIndex) ? targetIndex : Math.round(Number(getIndex?.()) || position);
        clearGesture();
        cancelSettle();
        renderPosition(nextIndex);
      };

      return { select, step, reset, refresh, cancel: () => { clearGesture(); cancelSettle(); } };
    };

    document.querySelectorAll('[data-ayv2-portal]').forEach((portal) => document.body.appendChild(portal));

    const header = document.querySelector('[data-ayv2-header]');
    const headerSection = header?.closest('.shopify-section');
    if (header && headerSection && !headerSection.dataset.ayv2FlowGapReady) {
      const naturalSectionTop = Math.max(0, headerSection.getBoundingClientRect().top + window.scrollY);
      headerSection.style.setProperty('--ayv2-header-flow-gap', `${Math.round(naturalSectionTop * 100) / 100}px`);
      headerSection.dataset.ayv2FlowGapReady = 'true';
    }
    const updateStickyHeader = () => {
      if (!header || !headerSection) return;
      const announcementHeight = header.querySelector('.ayv2-announcement')?.offsetHeight || 0;
      headerSection.classList.add('ayv2-header-section');
      headerSection.style.setProperty('--ayv2-header-offset', `${announcementHeight}px`);
      header.classList.toggle('is-stuck', window.scrollY > announcementHeight + 1);
    };
    updateStickyHeader();
    window.addEventListener('scroll', updateStickyHeader, { passive: true });
    window.addEventListener('resize', updateStickyHeader, { passive: true });
    if ('ResizeObserver' in window && header) new ResizeObserver(updateStickyHeader).observe(header);

    const overlay = document.querySelector('.ayv2-drawer-overlay');
    const drawers = [...document.querySelectorAll('[data-ayv2-drawer]')];
    const quickviewRoot = document.querySelector('[data-ayv2-quickview-root]');
    const contentModalRoot = document.querySelector('[data-ayv2-content-modal-root]');
    let pageLockState = null;
    const syncPageLock = () => {
      const locked = Boolean(drawers.some((drawer) => drawer.classList.contains('is-open')) || quickviewRoot?.classList.contains('is-open') || contentModalRoot?.classList.contains('is-open'));
      if (locked && !pageLockState) {
        pageLockState = {
          scrollY: window.scrollY,
          position: document.body.style.position,
          top: document.body.style.top,
          left: document.body.style.left,
          right: document.body.style.right,
          width: document.body.style.width
        };
        document.documentElement.classList.add('ayv2-modal-open');
        document.body.classList.add('ayv2-modal-open');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${pageLockState.scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      } else if (!locked) {
        const hadAyv2Lock = document.documentElement.classList.contains('ayv2-modal-open') || document.body.classList.contains('ayv2-modal-open');
        const fallbackTop = Number.parseFloat(document.body.style.top || '0');
        const restoreScrollY = pageLockState?.scrollY ?? (Number.isFinite(fallbackTop) ? Math.abs(fallbackTop) : window.scrollY);
        document.documentElement.classList.remove('ayv2-modal-open');
        document.body.classList.remove('ayv2-modal-open');
        document.body.style.position = pageLockState?.position || '';
        document.body.style.top = pageLockState?.top || '';
        document.body.style.left = pageLockState?.left || '';
        document.body.style.right = pageLockState?.right || '';
        document.body.style.width = pageLockState?.width || '';
        pageLockState = null;
        if (hadAyv2Lock) window.scrollTo(0, restoreScrollY);
      }
    };
    let drawerTrigger = null;
    const closeDrawers = () => {
      drawers.forEach((drawer) => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.inert = true;
      });
      overlay?.classList.remove('is-open');
      syncPageLock();
      if (drawerTrigger?.isConnected) drawerTrigger.focus({ preventScroll: true });
      drawerTrigger = null;
    };
    const openDrawer = (name) => {
      const trigger = document.activeElement;
      closeDrawers();
      drawerTrigger = trigger;
      const drawer = document.querySelector(`[data-ayv2-drawer="${name}"]`);
      if (!drawer) return;
      drawer.inert = false;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay?.classList.add('is-open');
      syncPageLock();
      drawer.querySelector('button, input, summary')?.focus({ preventScroll: true });
    };
    document.addEventListener('click', (event) => {
      const open = event.target.closest('[data-ayv2-open]');
      if (open) {
        event.preventDefault();
        openDrawer(open.dataset.ayv2Open);
        return;
      }
      if (event.target.closest('[data-ayv2-close]')) closeDrawers();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const drawer = drawers.find((item) => item.classList.contains('is-open'));
      if (!drawer) return;
      const controls = [...drawer.querySelectorAll('a[href],button:not([disabled]),input,select,summary,[tabindex="0"]')].filter((item) => item.getClientRects().length);
      const first = controls[0], last = controls[controls.length - 1];
      if (!first) return;
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    const languageSelect = document.querySelector('[data-hugyoo-language]');
    languageSelect?.addEventListener('change', () => {
      const form = languageSelect.form;
      let returnTo = form.querySelector('[name="return_to"]');
      if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo); }
      returnTo.value = location.pathname + location.search;
      form.requestSubmit();
    });
    let toastTimer;
    const showToast = (message) => {
      const box = document.querySelector('[data-ayv2-toast-box]');
      if (!box) return;
      box.textContent = message;
      box.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => box.classList.remove('is-visible'), 2300);
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ayv2-toast]');
      if (!trigger) return;
      event.preventDefault();
      showToast(trigger.dataset.ayv2Toast || uiText('This action is not available.'));
    });

    let quickviewReturnFocus = null;
    let quickviewSessionId = 0;
    let quickviewPendingAdd = null;
    let quickviewAbortController = null;
    let quickviewProduct = null;
    let quickviewSelectedOptions = [];
    let quickviewActiveVariant = null;
    let quickviewMedia = [];
    let quickviewActiveMediaIndex = 0;
    let quickviewFallback = {};
    let quickviewGalleryController = null;
    let quickviewMediaLoadVersion = 0;
    const quickviewProductCache = new Map();
    const quickviewMainImageCache = new Map();

    const quickviewNode = (selector) => quickviewRoot?.querySelector(selector);
    const setQuickviewText = (selector, value) => {
      const node = quickviewNode(selector);
      if (node) node.textContent = value || '';
    };
    const formatMoney = (cents, fallback = '') => {
      const amount = Number(cents);
      if (!Number.isFinite(amount)) return fallback;
      const currency = window.Shopify?.currency?.active || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(amount / 100);
      } catch (_) {
        return `$${(amount / 100).toFixed(2)}`;
      }
    };
    const normalizeImageUrl = (value) => {
      const source = typeof value === 'string' ? value : value?.src || value?.url;
      if (!source) return '';
      return source.startsWith('//') ? `${window.location.protocol}${source}` : source;
    };
    const normalizeMediaItem = (value, fallbackAlt = '') => {
      const src = normalizeImageUrl(value);
      if (!src) return null;
      return {
        src,
        thumb: normalizeImageUrl(value?.thumb),
        alt: String(value?.alt || fallbackAlt || '').trim(),
        role: String(value?.role || '').trim()
      };
    };
    const resizeShopifyImageUrl = (value, width) => {
      const source = normalizeImageUrl(value);
      if (!source || !width) return source;
      try {
        const url = new URL(source, window.location.origin);
        if (url.pathname.includes('/cdn/shop/')) url.searchParams.set('width', String(width));
        return url.toString();
      } catch (_) {
        return source;
      }
    };
    const uniqueValues = (values) => [...new Set(values.filter(Boolean))];
    const mediaFileKey = (value) => {
      const source = normalizeImageUrl(value);
      if (!source) return '';
      try {
        const pathname = decodeURIComponent(new URL(source, window.location.origin).pathname);
        return pathname.split('/').pop()?.toLowerCase() || pathname.toLowerCase();
      } catch (_) {
        return source.split('?')[0].split('#')[0].split('/').pop()?.toLowerCase() || source.toLowerCase();
      }
    };
    const mediaProductFamily = (value) => mediaFileKey(value).match(/^(hugyoo-\d{2}-)/i)?.[1]?.toLowerCase() || '';
    const uniqueProductMedia = (values, expectedFamily = '') => {
      const seen = new Map();
      const result = [];
      values.forEach((value) => {
        const media = normalizeMediaItem(value);
        const key = mediaFileKey(media);
        if (!media || !key) return;
        const family = mediaProductFamily(media);
        if (expectedFamily && family && family !== expectedFamily) return;
        if (seen.has(key)) {
          const existing = result[seen.get(key)];
          if (media.alt) existing.alt = media.alt;
          if (!existing.thumb && media.thumb) existing.thumb = media.thumb;
          if (!existing.role && media.role) existing.role = media.role;
          return;
        }
        seen.set(key, result.length);
        result.push(media);
      });
      return result;
    };
    const sharedQuickviewMedia = () => [
      {
        src: quickviewRoot?.dataset.ayv2SharedCapSrc || '',
        thumb: quickviewRoot?.dataset.ayv2SharedCapSrc || '',
        alt: quickviewRoot?.dataset.ayv2SharedCapAlt || '',
        role: quickviewRoot?.dataset.ayv2SharedCapLabel || 'Inside the wig cap'
      },
      {
        src: quickviewRoot?.dataset.ayv2SharedLaceSrc || '',
        thumb: resizeShopifyImageUrl(quickviewRoot?.dataset.ayv2SharedLaceSrc || '', 180),
        alt: quickviewRoot?.dataset.ayv2SharedLaceAlt || '',
        role: uiText('Lace and knots close-up')
      }
    ].filter((media) => media.src);
    const quickviewProductCacheKey = (productUrl) => {
      const resolved = new URL(productUrl, window.location.origin);
      if (resolved.origin !== window.location.origin || !/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:collections\/[^/]+\/)?products\/[^/]+\/?$/i.test(resolved.pathname)
        || resolved.searchParams.has('view') || resolved.searchParams.has('preview_key')) {
        throw new Error(uiText('This product is not available for quick shopping.'));
      }
      return `product:${resolved.pathname}`;
    };
    const productTitleKey = (value) => String(value || '').normalize('NFKC').toLowerCase().replace(/×/g, 'x').replace(/\s+/g, ' ').trim();
    const normalizeVariant = (variant) => ({
      id: Number(variant.id),
      available: variant.available === true,
      price: Number(variant.price),
      compare_at_price: Number(variant.compare_at_price || variant.compareAtPrice || 0),
      options: Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3].filter((value) => value != null),
      image: normalizeImageUrl(variant.featured_image || variant.featured_media?.preview_image)
    });
    const normalizeProductJson = (product, productUrl) => {
      const variants = (product.variants || []).map(normalizeVariant);
      const rawOptions = product.options || [];
      const options = rawOptions.map((option, index) => {
        const name = typeof option === 'string' ? option : option.name;
        const values = typeof option === 'string' ? uniqueValues(variants.map((variant) => variant.options[index])) : uniqueValues(option.values || variants.map((variant) => variant.options[index]));
        return { name, values };
      }).filter((option) => option.name && !(option.name === 'Title' && option.values.length === 1 && option.values[0] === 'Default Title'));
      const images = uniqueProductMedia([
        ...(product.media || []).map((media) => ({
          src: normalizeImageUrl(media.preview_image || media.image || media.src),
          alt: media.alt || media.altText || ''
        })),
        normalizeImageUrl(product.featured_image),
        ...(product.images || []).map(normalizeImageUrl),
        ...variants.map((variant) => variant.image)
      ]);
      return { id: String(product.id), handle: product.handle, title: product.title, url: productUrl, variants, options, images, isPreview: false };
    };
    const fetchQuickviewProduct = async (productUrl, signal) => {
      const resolved = new URL(productUrl, window.location.origin);
      quickviewProductCacheKey(productUrl);
      const requestUrl = `${resolved.origin}${resolved.pathname.replace(/\/$/, '')}.js`;
      const response = await fetch(requestUrl, {
        signal,
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error(`Product request failed (${response.status})`);
      const product = await response.json();
      const expectedHandle = decodeURIComponent(resolved.pathname.replace(/\/$/, '').split('/').pop());
      if (!product.id || product.handle !== expectedHandle || !Array.isArray(product.variants)) {
        throw new Error(uiText('The product details could not be verified. Please open the product page.'));
      }
      return normalizeProductJson(product, resolved.pathname);
    };

    const quickviewMainMediaUrl = (media, index) => index === 0 && media.src === quickviewFallback.image
      ? media.src
      : resizeShopifyImageUrl(media.src, 900);
    const preloadQuickviewImage = (source, priority = 'auto') => {
      const url = normalizeImageUrl(source);
      if (!url) return null;
      const cached = quickviewMainImageCache.get(url);
      if (cached && !cached.failed) {
        if (priority === 'high' && 'fetchPriority' in cached.loader) cached.loader.fetchPriority = 'high';
        return cached;
      }
      const loader = new Image();
      loader.decoding = 'async';
      if ('fetchPriority' in loader) loader.fetchPriority = priority;
      const entry = { loader, ready: false, failed: false, promise: null };
      entry.promise = new Promise((resolve) => {
        loader.addEventListener('load', () => {
          const finish = () => {
            entry.ready = true;
            resolve(true);
          };
          if (typeof loader.decode === 'function') loader.decode().then(finish).catch(finish);
          else finish();
        }, { once: true });
        loader.addEventListener('error', () => {
          entry.failed = true;
          resolve(false);
        }, { once: true });
      });
      quickviewMainImageCache.set(url, entry);
      loader.src = url;
      return entry;
    };
    const loadQuickviewSlide = (index, priority = 'high') => {
      const media = quickviewMedia[index];
      const slide = quickviewNode(`[data-ayv2-quick-slide][data-media-index="${index}"]`);
      if (!media || !slide) return null;
      const fullSource = quickviewMainMediaUrl(media, index);
      const entry = preloadQuickviewImage(fullSource, priority);
      const showFullImage = () => {
        if (entry?.ready && slide.isConnected) slide.src = fullSource;
      };
      if (entry?.ready) showFullImage();
      else entry?.promise.then(showFullImage);
      return entry;
    };
    const waitForQuickviewImage = (image) => new Promise((resolve) => {
      if (image.complete) {
        resolve();
        return;
      }
      const finish = () => {
        image.removeEventListener('load', finish);
        image.removeEventListener('error', finish);
        resolve();
      };
      image.addEventListener('load', finish, { once: true });
      image.addEventListener('error', finish, { once: true });
    });
    const startQuickviewMediaLoading = () => {
      const version = ++quickviewMediaLoadVersion;
      const activeIndex = quickviewActiveMediaIndex;
      const lead = loadQuickviewSlide(activeIndex);
      const thumbnails = [...(quickviewNode('[data-ayv2-quick-thumbs]')?.querySelectorAll('img') || [])];
      // Let the visible image and thumbnail strip finish before fetching other large images.
      Promise.all([lead?.promise, ...thumbnails.map(waitForQuickviewImage)]).then(async () => {
        for (let index = 0; index < quickviewMedia.length; index += 1) {
          if (version !== quickviewMediaLoadVersion || !quickviewRoot?.classList.contains('is-open')) return;
          if (index === activeIndex) continue;
          await loadQuickviewSlide(index, 'low')?.promise;
        }
      });
    };
    const ensureQuickviewGallery = () => {
      const surface = quickviewNode('[data-ayv2-quick-main]');
      if (!surface) return null;
      let viewport = surface.querySelector('[data-ayv2-quick-viewport]');
      let track = surface.querySelector('[data-ayv2-quick-track]');
      if (!viewport || !track) {
        viewport = document.createElement('div');
        track = document.createElement('div');
        viewport.className = 'ayv2-quickview__gallery-viewport';
        viewport.dataset.ayv2QuickViewport = '';
        track.className = 'ayv2-quickview__gallery-track';
        track.dataset.ayv2QuickTrack = '';
        viewport.append(track);
        const originalImage = quickviewNode('[data-ayv2-quick-image]');
        const placeholder = quickviewNode('[data-ayv2-quick-placeholder]');
        originalImage?.remove();
        surface.insertBefore(viewport, placeholder || surface.firstChild);
      }
      if (!quickviewGalleryController) {
        quickviewGalleryController = createTrackGallery({
          surface,
          viewport,
          track,
          getCount: () => quickviewMedia.length,
          getIndex: () => quickviewActiveMediaIndex,
          navigationSelector: '[data-ayv2-quick-nav]',
          onSettled: (index, { scroll = false } = {}) => {
            quickviewActiveMediaIndex = index;
            loadQuickviewSlide(index);
            quickviewRoot?.querySelectorAll('[data-ayv2-quick-media]').forEach((button) => {
              const active = Number(button.dataset.ayv2QuickMedia) === index;
              button.classList.toggle('is-active', active);
              button.setAttribute('aria-current', active ? 'true' : 'false');
            });
            if (scroll) {
              const thumb = quickviewRoot?.querySelector(`[data-ayv2-quick-media="${index}"]`);
              const strip = thumb?.parentElement;
              if (thumb && strip) {
                const left = thumb.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2;
                strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
              }
            }
          }
        });
        window.addEventListener('resize', () => quickviewGalleryController?.refresh(), { passive: true });
      }
      return { surface, viewport, track, controller: quickviewGalleryController };
    };
    const clearQuickviewMediaTransition = () => {
      quickviewMediaLoadVersion += 1;
      quickviewGalleryController?.cancel();
      quickviewRoot?.classList.remove('is-media-switching', 'is-media-loading');
    };
    const selectQuickviewMedia = (index, { direction = 0, animate = true } = {}) => {
      if (!quickviewMedia.length) return;
      const galleryState = ensureQuickviewGallery();
      if (!galleryState?.controller) return;
      const options = { animate, meta: { scroll: true } };
      if (direction) galleryState.controller.step(direction, options);
      else galleryState.controller.select(index, options);
    };
    const renderQuickviewMedia = (images, title) => {
      const expectedFamily = mediaProductFamily(quickviewFallback.image);
      const fallbackMedia = quickviewFallback.image ? [{ src: quickviewFallback.image, alt: quickviewFallback.imageAlt }] : [];
      const actualImages = images || [];
      const sharedMedia = expectedFamily && actualImages.length ? sharedQuickviewMedia() : [];
      const candidates = actualImages.length
        ? [...actualImages.slice(0, 4), ...sharedMedia, ...actualImages.slice(4)]
        : fallbackMedia;
      const nextMedia = uniqueProductMedia(candidates, expectedFamily).slice(0, 6);
      const unchangedMedia = nextMedia.length > 0 && nextMedia.length === quickviewMedia.length
        && nextMedia.every((media, index) => media.src === quickviewMedia[index].src && media.thumb === quickviewMedia[index].thumb);
      quickviewMedia = nextMedia;
      const galleryState = ensureQuickviewGallery();
      const placeholder = quickviewNode('[data-ayv2-quick-placeholder]');
      const thumbs = quickviewNode('[data-ayv2-quick-thumbs]');
      const navigation = [...(quickviewRoot?.querySelectorAll('[data-ayv2-quick-nav]') || [])];
      if (unchangedMedia && galleryState?.track?.children.length === nextMedia.length && thumbs?.children.length === nextMedia.length) {
        nextMedia.forEach((media, index) => {
          const imageAlt = media.alt || `${title || quickviewFallback.title || 'Product'}, image ${index + 1}.`;
          galleryState.track.children[index].alt = imageAlt;
          thumbs.children[index].querySelector('img').alt = imageAlt;
          thumbs.children[index].setAttribute('aria-label', media.alt ? `Show image: ${media.alt}` : `View ${title || 'product'} image ${index + 1}`);
        });
        startQuickviewMediaLoading();
        return;
      }
      quickviewMediaLoadVersion += 1;
      if (thumbs) thumbs.replaceChildren();
      if (!quickviewMedia.length) {
        galleryState?.controller?.cancel();
        galleryState?.track?.replaceChildren();
        if (galleryState?.viewport) galleryState.viewport.hidden = true;
        if (placeholder) placeholder.hidden = false;
        if (thumbs) thumbs.hidden = true;
        navigation.forEach((button) => { button.hidden = true; });
        return;
      }
      if (!galleryState?.track || !galleryState.controller) return;
      galleryState.controller.cancel();
      galleryState.track.replaceChildren();
      galleryState.viewport.hidden = false;
      if (placeholder) placeholder.hidden = true;
      quickviewMedia.forEach((media, index) => {
        const slide = document.createElement('img');
        const button = document.createElement('button');
        const thumbImage = document.createElement('img');
        const fullSource = quickviewMainMediaUrl(media, index);
        const previewSource = media.thumb || resizeShopifyImageUrl(media.src, 180) || fullSource;
        const imageAlt = media.alt || `${title || quickviewFallback.title || 'Product'}, image ${index + 1}.`;
        const cached = quickviewMainImageCache.get(fullSource);
        slide.className = 'ayv2-quickview__gallery-slide';
        slide.dataset.ayv2QuickSlide = '';
        slide.dataset.mediaIndex = String(index);
        if (index === 0) slide.dataset.ayv2QuickImage = '';
        slide.alt = imageAlt;
        slide.loading = 'eager';
        slide.decoding = 'async';
        slide.draggable = false;
        slide.width = 1254;
        slide.height = 1254;
        if ('fetchPriority' in slide) slide.fetchPriority = index === 0 ? 'high' : 'auto';
        slide.src = index === 0 || cached?.ready ? fullSource : previewSource;
        galleryState.track.append(slide);
        button.className = 'ayv2-pdp__thumb';
        button.type = 'button';
        button.dataset.ayv2QuickMedia = String(index);
        button.setAttribute('aria-label', media.alt ? `Show image: ${media.alt}` : `View ${title || 'product'} image ${index + 1}`);
        thumbImage.alt = imageAlt;
        thumbImage.loading = 'eager';
        thumbImage.decoding = 'async';
        if ('fetchPriority' in thumbImage) thumbImage.fetchPriority = 'high';
        thumbImage.width = 180;
        thumbImage.height = 180;
        thumbImage.src = index === 0 && quickviewFallback.imageReady ? fullSource : previewSource;
        button.append(thumbImage);
        thumbs?.append(button);
      });
      if (thumbs) thumbs.hidden = quickviewMedia.length < 2;
      navigation.forEach((button) => { button.hidden = quickviewMedia.length < 2; });
      quickviewActiveMediaIndex = 0;
      galleryState.controller.reset(0, { meta: { scroll: false } });
      startQuickviewMediaLoading();
    };
    const refreshQuickviewVariant = () => {
      const variants = quickviewProduct?.variants || [];
      quickviewActiveVariant = variants.find((variant) => variant.options.every((value, index) => value === quickviewSelectedOptions[index])) || (quickviewProduct?.options.length ? null : variants[0]) || null;
      const price = quickviewNode('[data-ayv2-quick-price]');
      const compare = quickviewNode('[data-ayv2-quick-compare]');
      const stock = quickviewNode('[data-ayv2-quick-stock]');
      const addButton = quickviewNode('[data-ayv2-quick-add]');
      if (price) price.textContent = quickviewActiveVariant ? formatMoney(quickviewActiveVariant.price, quickviewFallback.price) : quickviewFallback.price || uiText('Choose available options');
      if (compare) {
        const showCompare = Boolean(quickviewActiveVariant?.compare_at_price > quickviewActiveVariant?.price);
        compare.textContent = showCompare ? formatMoney(quickviewActiveVariant.compare_at_price, quickviewFallback.compare) : '';
        compare.hidden = !showCompare;
      }
      if (quickviewActiveVariant?.image) {
        const variantImageKey = mediaFileKey(quickviewActiveVariant.image);
        const imageIndex = quickviewMedia.findIndex((source) => mediaFileKey(source) === variantImageKey);
        if (imageIndex >= 0) selectQuickviewMedia(imageIndex);
      }
      if (stock) {
        stock.textContent = quickviewActiveVariant
          ? (quickviewActiveVariant.available ? uiText('In stock — ready to add.') : uiText('This option is sold out.'))
          : uiText('Choose an available combination.');
        stock.classList.toggle('is-available', Boolean(quickviewActiveVariant?.available));
      }
      if (addButton) {
        addButton.disabled = Boolean(quickviewPendingAdd) || Boolean(quickviewProduct?.isPreview) || !quickviewActiveVariant?.available || !quickviewActiveVariant?.id;
        addButton.textContent = quickviewProduct?.isPreview ? uiText('UNAVAILABLE') : (quickviewPendingAdd ? uiText('ADDING…') : (quickviewActiveVariant?.available ? uiText('ADD TO CART') : uiText('SOLD OUT')));
      }
    };
    const renderQuickviewOptions = (product) => {
      const optionsRoot = quickviewNode('[data-ayv2-quick-options]');
      if (!optionsRoot) return;
      optionsRoot.replaceChildren();
      const defaultVariant = product.variants.find((variant) => variant.available) || product.variants[0] || null;
      quickviewSelectedOptions = defaultVariant?.options ? [...defaultVariant.options] : [];
      product.options.forEach((option, index) => {
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend');
        const values = document.createElement('div');
        fieldset.className = 'ayv2-quickview__option';
        legend.textContent = uiText(option.name);
        values.className = 'ayv2-option__values';
        option.values.forEach((value) => {
          const button = document.createElement('button');
          button.className = 'ayv2-option-button';
          button.type = 'button';
          button.textContent = uiOption(option.name, value);
          button.dataset.ayv2QuickOptionValue = value;
          button.dataset.optionIndex = String(index);
          const selected = quickviewSelectedOptions[index] === value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          values.append(button);
        });
        fieldset.append(legend, values);
        optionsRoot.append(fieldset);
      });
      refreshQuickviewVariant();
    };
    const closeQuickview = () => {
      if (!quickviewRoot?.classList.contains('is-open')) return;
      quickviewSessionId += 1;
      quickviewAbortController?.abort();
      quickviewAbortController = null;
      quickviewRoot.classList.remove('is-open');
      quickviewRoot.classList.remove('is-loading');
      clearQuickviewMediaTransition();
      quickviewRoot.setAttribute('aria-hidden', 'true');
      quickviewNode('[role="dialog"]')?.setAttribute('aria-busy', 'false');
      quickviewNode('[data-ayv2-quick-options]')?.setAttribute('aria-busy', 'false');
      syncPageLock();
      quickviewReturnFocus?.focus?.({ preventScroll: true });
      quickviewReturnFocus = null;
    };
    const openQuickview = async (trigger) => {
      if (!quickviewRoot) return;
      quickviewSessionId += 1;
      closeDrawers();
      quickviewAbortController?.abort();
      quickviewAbortController = new AbortController();
      const requestController = quickviewAbortController;
      quickviewReturnFocus = trigger;
      quickviewProduct = null;
      quickviewActiveVariant = null;
      quickviewFallback = {
        productId: trigger.dataset.productId || '',
        title: trigger.dataset.title || 'Product',
        price: trigger.dataset.price || '',
        compare: trigger.dataset.compare || '',
        image: normalizeImageUrl(trigger.dataset.image || ''),
        imageAlt: trigger.dataset.imageAlt || trigger.closest('article')?.querySelector('img')?.alt || '',
        url: trigger.dataset.productUrl || ''
      };
      const cardImage = trigger.closest('article')?.querySelector('img');
      quickviewFallback.imageReady = Boolean(cardImage?.complete && cardImage.naturalWidth > 0
        && normalizeImageUrl(cardImage.currentSrc || cardImage.src) === quickviewFallback.image);
      setQuickviewText('[data-ayv2-quick-title]', quickviewFallback.title);
      setQuickviewText('[data-ayv2-quick-price]', quickviewFallback.price);
      setQuickviewText('[data-ayv2-quick-compare]', quickviewFallback.compare);
      setQuickviewText('[data-ayv2-quick-stock]', quickviewFallback.url ? uiText('Loading options…') : uiText('This product is currently unavailable.'));
      setQuickviewText('[data-ayv2-quick-status]', '');
      const compare = quickviewNode('[data-ayv2-quick-compare]');
      if (compare) compare.hidden = !quickviewFallback.compare;
      const badge = quickviewNode('[data-ayv2-quick-badge]');
      if (badge) {
        badge.textContent = trigger.dataset.badge || '';
        badge.hidden = !trigger.dataset.badge;
      }
      const addButton = quickviewNode('[data-ayv2-quick-add]');
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = quickviewFallback.url ? uiText('LOADING…') : uiText('NOT AVAILABLE');
      }
      const optionsRoot = quickviewNode('[data-ayv2-quick-options]');
      optionsRoot?.replaceChildren();
      optionsRoot?.setAttribute('aria-busy', quickviewFallback.url ? 'true' : 'false');
      const quantity = quickviewNode('[data-ayv2-quick-quantity]');
      if (quantity) quantity.value = '1';
      const fullLink = quickviewNode('[data-ayv2-quick-full-link]');
      if (fullLink) {
        fullLink.href = quickviewFallback.url || '#';
        fullLink.hidden = !quickviewFallback.url;
      }
      renderQuickviewMedia([], quickviewFallback.title);
      quickviewRoot.classList.remove('is-loading');
      quickviewRoot.classList.add('is-open');
      quickviewRoot.setAttribute('aria-hidden', 'false');
      quickviewNode('[role="dialog"]')?.setAttribute('aria-busy', 'false');
      syncPageLock();
      window.requestAnimationFrame(() => quickviewNode('[role="dialog"]')?.focus({ preventScroll: true }));
      if (!quickviewFallback.url) return;
      try {
        const cacheKey = quickviewProductCacheKey(quickviewFallback.url);
        const product = quickviewProductCache.get(cacheKey)
          || await fetchQuickviewProduct(quickviewFallback.url, requestController.signal);
        if (requestController !== quickviewAbortController || requestController.signal.aborted) return;
        if (quickviewFallback.productId && String(product.id) !== quickviewFallback.productId) {
          throw new Error(uiText('The product details did not match the selected item.'));
        }
        quickviewProductCache.set(cacheKey, product);
        quickviewProduct = product;
        setQuickviewText('[data-ayv2-quick-title]', product.title || quickviewFallback.title);
        renderQuickviewMedia(product.images, product.title);
        renderQuickviewOptions(product);
      } catch (error) {
        if (error.name !== 'AbortError') {
          setQuickviewText('[data-ayv2-quick-stock]', uiText('Options could not be loaded. Open the full product page to continue.'));
          setQuickviewText('[data-ayv2-quick-status]', uiText('Please try again or view the product details.'));
          if (addButton) { addButton.disabled = true; addButton.textContent = uiText('UNAVAILABLE'); }
        }
      } finally {
        if (requestController === quickviewAbortController) {
          quickviewRoot.classList.remove('is-loading');
          quickviewNode('[role="dialog"]')?.setAttribute('aria-busy', 'false');
          optionsRoot?.setAttribute('aria-busy', 'false');
        }
      }
    };
    const addQuickviewToCart = async () => {
      const addButton = quickviewNode('[data-ayv2-quick-add]');
      const quantityInput = quickviewNode('[data-ayv2-quick-quantity]');
      if (quickviewPendingAdd || quickviewProduct?.isPreview || !addButton || !quickviewActiveVariant?.id || !quickviewActiveVariant.available) return;
      const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
      const request = { sessionId: quickviewSessionId, product: quickviewProduct, variantId: quickviewActiveVariant.id };
      quickviewPendingAdd = request;
      const isCurrentView = () => quickviewRoot?.classList.contains('is-open')
        && quickviewSessionId === request.sessionId && quickviewProduct === request.product;
      addButton.disabled = true;
      addButton.textContent = uiText('ADDING…');
      setQuickviewText('[data-ayv2-quick-status]', uiText('Adding your selection…'));
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: request.variantId, quantity }] })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || uiText('This item could not be added.'));
        document.dispatchEvent(new CustomEvent('ayv2:cart-updated', { detail: payload }));
        if (isCurrentView()) {
          setQuickviewText('[data-ayv2-quick-status]', uiText('Added to your bag.'));
          showToast(uiText('ADDED TO YOUR BAG'));
        }
      } catch (error) {
        if (isCurrentView()) setQuickviewText('[data-ayv2-quick-status]', error.message || uiText('This item could not be added.'));
      } finally {
        if (quickviewPendingAdd === request) quickviewPendingAdd = null;
        if (quickviewRoot?.classList.contains('is-open')) refreshQuickviewVariant();
      }
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ayv2-quickbuy]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        openQuickview(trigger);
        return;
      }
      if (event.target.closest('[data-ayv2-quickview-close]')) {
        event.preventDefault();
        closeQuickview();
        return;
      }
      const option = event.target.closest('[data-ayv2-quick-option-value]');
      if (option && quickviewRoot?.contains(option)) {
        event.preventDefault();
        const index = Number(option.dataset.optionIndex);
        quickviewSelectedOptions[index] = option.dataset.ayv2QuickOptionValue;
        option.parentElement?.querySelectorAll('[data-ayv2-quick-option-value]').forEach((button) => {
          const selected = button === option;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        refreshQuickviewVariant();
        return;
      }
      const mediaButton = event.target.closest('[data-ayv2-quick-media]');
      if (mediaButton && quickviewRoot?.contains(mediaButton)) {
        event.preventDefault();
        selectQuickviewMedia(mediaButton.dataset.ayv2QuickMedia);
        return;
      }
      const mediaNavigation = event.target.closest('[data-ayv2-quick-nav]');
      if (mediaNavigation && quickviewRoot?.contains(mediaNavigation)) {
        event.preventDefault();
        const direction = mediaNavigation.dataset.ayv2QuickNav === 'previous' ? -1 : 1;
        selectQuickviewMedia(quickviewActiveMediaIndex + direction, { direction });
        return;
      }
      const quantityButton = event.target.closest('[data-ayv2-quick-qty]');
      if (quantityButton && quickviewRoot?.contains(quantityButton)) {
        event.preventDefault();
        const input = quickviewNode('[data-ayv2-quick-quantity]');
        if (input) {
          const current = Math.max(1, Number.parseInt(input.value || '1', 10) || 1);
          input.value = String(quantityButton.dataset.ayv2QuickQty === 'increase' ? current + 1 : Math.max(1, current - 1));
        }
        return;
      }
      if (event.target.closest('[data-ayv2-quick-add]')) {
        event.preventDefault();
        addQuickviewToCart();
      }
    });
    quickviewRoot?.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !quickviewRoot.classList.contains('is-open')) return;
      const focusable = [...quickviewRoot.querySelectorAll('button:not([disabled]), a[href]:not([hidden]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')]
        .filter((element) => !element.hidden && element.getClientRects().length);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    let contentModalReturnFocus = null;
    const closeContentModal = () => {
      if (!contentModalRoot?.classList.contains('is-open')) return;
      contentModalRoot.classList.remove('is-open');
      contentModalRoot.classList.remove('is-membership');
      contentModalRoot.setAttribute('aria-hidden', 'true');
      syncPageLock();
      contentModalReturnFocus?.focus?.({ preventScroll: true });
      contentModalReturnFocus = null;
    };
    const openContentModal = (trigger) => {
      if (!contentModalRoot) return;
      const key = trigger.dataset.ayv2ContentModal;
      const matchingTemplates = [...document.querySelectorAll('[data-ayv2-modal-template]')].filter((item) => item.dataset.ayv2ModalTemplate === key);
      const template = matchingTemplates[matchingTemplates.length - 1];
      const title = contentModalRoot.querySelector('[data-ayv2-content-modal-title]');
      const body = contentModalRoot.querySelector('[data-ayv2-content-modal-body]');
      if (!template || !body) return;
      contentModalReturnFocus = trigger;
      if (title) title.textContent = trigger.dataset.ayv2ModalTitle || uiText('Product information');
      body.innerHTML = template.innerHTML;
      body.scrollTop = 0;
      contentModalRoot.classList.toggle('is-membership', Boolean(body.querySelector('[data-ayv2-membership]')));
      contentModalRoot.classList.add('is-open');
      contentModalRoot.setAttribute('aria-hidden', 'false');
      syncPageLock();
      window.requestAnimationFrame(() => contentModalRoot.querySelector('[role="dialog"]')?.focus({ preventScroll: true }));
    };
    document.addEventListener('click', (event) => {
      const memberTab = event.target.closest('[data-ayv2-member-tab]');
      if (memberTab) {
        event.preventDefault();
        const memberModal = memberTab.closest('[data-ayv2-membership]');
        const selected = memberTab.dataset.ayv2MemberTab;
        memberModal?.querySelectorAll('[data-ayv2-member-tab]').forEach((item) => {
          const active = item.dataset.ayv2MemberTab === selected;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        memberModal?.querySelectorAll('[data-ayv2-member-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.ayv2MemberPanel !== selected;
        });
        return;
      }
      const trigger = event.target.closest('[data-ayv2-content-modal]');
      if (trigger) {
        event.preventDefault();
        openContentModal(trigger);
        return;
      }
      if (event.target.closest('[data-ayv2-content-modal-close]')) {
        event.preventDefault();
        closeContentModal();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (contentModalRoot?.classList.contains('is-open')) closeContentModal();
      else if (quickviewRoot?.classList.contains('is-open')) closeQuickview();
      else closeDrawers();
    });

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.ayv2-option-button');
      const group = button?.closest('.ayv2-option:not([data-ayv2-option])');
      if (!button || !group) return;
      group.querySelectorAll('.ayv2-option-button').forEach((item) => item.classList.remove('is-selected'));
      button.classList.add('is-selected');
    });

    const reveals = [...document.querySelectorAll('.ayv2-reveal')];
    if ('IntersectionObserver' in window) {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
      reveals.forEach((item) => revealObserver.observe(item));
    } else {
      reveals.forEach((item) => item.classList.add('is-visible'));
    }

    const setupTimedStack = (root, slideSelector, dotSelector, stateNames, fallbackInterval) => {
      const slides = [...root.querySelectorAll(slideSelector)];
      const dots = [...root.querySelectorAll(dotSelector)];
      if (slides.length < 2) return;
      let index = 0;
      let timer = null;
      const intervalMs = Number(root.dataset.ayv2Interval) || fallbackInterval;
      const render = () => {
        slides.forEach((slide, slideIndex) => {
          const relative = (slideIndex - index + slides.length) % slides.length;
          stateNames.forEach((state) => slide.classList.remove(state));
          if (stateNames[relative]) slide.classList.add(stateNames[relative]);
          slide.setAttribute('aria-hidden', relative === 0 ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };
      const setActive = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        render();
      };
      const stop = () => {
        if (timer) window.clearTimeout(timer);
        timer = null;
      };
      const start = () => {
        stop();
        const tick = () => {
          setActive(index + 1);
          timer = window.setTimeout(tick, intervalMs);
        };
        timer = window.setTimeout(tick, intervalMs);
      };
      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => {
        setActive(dotIndex);
        start();
      }));
      render();
      window.requestAnimationFrame(() => root.classList.add('is-ready'));
      start();
    };

    document.querySelectorAll('[data-ayv2-hairline-carousel]').forEach((root) => {
      setupTimedStack(root, '[data-ayv2-hairline-slide]', '[data-ayv2-hairline-dot]', ['is-active','is-next','is-prev'], 2000);
    });

    document.querySelectorAll('[data-ayv2-quality-carousel]').forEach((root) => {
      setupTimedStack(root, '[data-ayv2-quality-slide]', '[data-ayv2-quality-dot]', ['is-active','is-back'], 3000);
    });

    document.querySelectorAll('[data-ayv2-slider]').forEach((slider) => {
      const track = slider.querySelector('.ayv2-slider__track');
      const cards = [...(track?.children || [])];
      const dots = [...slider.querySelectorAll('.ayv2-slider-dots button')];
      if (!track || cards.length < 2) return;
      const setActive = () => {
        const target = track.scrollLeft + track.clientWidth * .35;
        let index = 0;
        let distance = Infinity;
        cards.forEach((card, cardIndex) => {
          const delta = Math.abs(card.offsetLeft - target);
          if (delta < distance) { distance = delta; index = cardIndex; }
        });
        const dotIndex = Math.min(dots.length - 1, Math.max(0, index));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === dotIndex));
      };
      const scrollToCard = (card) => {
        if (!card) return;
        const left = card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
        track.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      };
      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(setActive, 80);
      }, { passive: true });
      dots.forEach((dot, index) => dot.addEventListener('click', () => scrollToCard(cards[index])));
      if (slider.hasAttribute('data-ayv2-autoplay') && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let active = 0;
        let interval = setInterval(() => {
          active = (active + 1) % cards.length;
          scrollToCard(cards[active]);
        }, 4300);
        slider.addEventListener('pointerdown', () => clearInterval(interval), { once: true });
      }
      setActive();
    });

    document.querySelectorAll('[data-ayv2-hotspot]').forEach((button) => {
      button.addEventListener('click', () => {
        const region = button.closest('[data-ayv2-hotspot-region]');
        const card = region?.querySelector('[data-ayv2-hotspot-card]');
        if (!card) return;
        region.querySelectorAll('[data-ayv2-hotspot]').forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-expanded', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-expanded', 'true');
        card.querySelector('small').textContent = button.dataset.number || '01';
        card.querySelector('h3').textContent = button.dataset.title || uiText('Product detail');
        card.querySelector('p').textContent = button.dataset.copy || uiText('More information is available in this section.');
      });
    });

    document.querySelectorAll('[data-ayv2-gallery]').forEach((gallery) => {
      const mainImage = gallery.querySelector('[data-ayv2-main-image]');
      const mainPlaceholder = gallery.querySelector('[data-ayv2-main-placeholder]');
      const mainSurface = gallery.querySelector('.ayv2-pdp__main');
      const thumbStrip = gallery.querySelector('.ayv2-pdp__thumbs');
      const thumbs = [...gallery.querySelectorAll('[data-ayv2-thumb]')];
      const previousButton = gallery.querySelector('[data-ayv2-gallery-prev]');
      const nextButton = gallery.querySelector('[data-ayv2-gallery-next]');
      let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      let galleryController = null;

      const syncMedia = (nextIndex, { scroll = true } = {}) => {
        if (!thumbs.length) return;
        const normalizedIndex = Math.max(0, Math.min(thumbs.length - 1, Math.round(nextIndex)));
        const thumb = thumbs[normalizedIndex];
        activeIndex = normalizedIndex;
        thumbs.forEach((item, index) => {
          const active = index === normalizedIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (mainPlaceholder && thumb.dataset.label) {
          mainPlaceholder.dataset.label = thumb.dataset.label;
        }

        if (scroll && thumbStrip) {
          const left = thumb.offsetLeft - (thumbStrip.clientWidth - thumb.clientWidth) / 2;
          thumbStrip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      };

      if (mainImage && mainSurface && thumbs.some((thumb) => thumb.dataset.full)) {
        const viewport = document.createElement('div');
        const track = document.createElement('div');
        viewport.className = 'ayv2-pdp__gallery-viewport';
        viewport.dataset.ayv2GalleryViewport = '';
        track.className = 'ayv2-pdp__gallery-track';
        track.dataset.ayv2GalleryTrack = '';
        viewport.append(track);
        mainImage.remove();
        mainSurface.insertBefore(viewport, mainSurface.firstChild);

        thumbs.forEach((thumb, index) => {
          const slide = index === activeIndex ? mainImage : document.createElement('img');
          const source = thumb.dataset.full;
          slide.classList.add('ayv2-pdp__gallery-slide');
          slide.dataset.ayv2GallerySlide = '';
          slide.dataset.mediaIndex = thumb.dataset.mediaIndex || String(index);
          slide.alt = thumb.dataset.alt || '';
          slide.loading = index < 4 ? 'eager' : 'lazy';
          slide.decoding = 'async';
          slide.draggable = false;
          if (index !== activeIndex && source) slide.src = source;
          if (!slide.hasAttribute('width')) slide.setAttribute('width', '1400');
          if (!slide.hasAttribute('height')) slide.setAttribute('height', '1400');
          track.append(slide);
        });

        galleryController = createTrackGallery({
          surface: mainSurface,
          viewport,
          track,
          getCount: () => thumbs.length,
          getIndex: () => activeIndex,
          navigationSelector: '[data-ayv2-gallery-nav]',
          onSettled: syncMedia
        });
        galleryController?.reset(activeIndex, { meta: { scroll: false } });
        window.addEventListener('resize', () => galleryController?.refresh(), { passive: true });
        window.requestAnimationFrame(() => {
          thumbs.forEach((thumb) => {
            if (!thumb.dataset.full) return;
            const preload = new Image();
            preload.decoding = 'async';
            preload.src = thumb.dataset.full;
          });
        });
      }

      const selectMedia = (nextIndex, { scroll = true, animate = true } = {}) => {
        if (!thumbs.length) return;
        if (galleryController) {
          galleryController.select(nextIndex, { animate, meta: { scroll } });
          return;
        }
        const normalizedIndex = (Number(nextIndex) + thumbs.length) % thumbs.length;
        const thumb = thumbs[normalizedIndex];
        if (mainImage && thumb.dataset.full) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = thumb.dataset.full;
          mainImage.alt = thumb.dataset.alt || '';
        }
        syncMedia(normalizedIndex, { scroll });
      };

      gallery.ayv2SelectMedia = selectMedia;
      gallery.ayv2ReplaceActiveMedia = (source, alt = '') => {
        const slides = [...gallery.querySelectorAll('[data-ayv2-gallery-slide]')];
        const image = slides[activeIndex] || mainImage;
        if (!image || !source) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = source;
        if (alt) image.alt = alt;
      };
      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => selectMedia(index));
      });
      previousButton?.addEventListener('click', () => galleryController
        ? galleryController.step(-1, { meta: { scroll: true } })
        : selectMedia(activeIndex - 1));
      nextButton?.addEventListener('click', () => galleryController
        ? galleryController.step(1, { meta: { scroll: true } })
        : selectMedia(activeIndex + 1));

      if (thumbs.length && !galleryController) selectMedia(activeIndex, { scroll: false, animate: false });
    });

    document.querySelectorAll('[data-ayv2-product]').forEach((productRoot) => {
      const variantsNode = productRoot.querySelector('[data-ayv2-variants]');
      if (!variantsNode) return;

      let variants = [];
      try { variants = JSON.parse(variantsNode.textContent); } catch (_) { return; }
      if (!Array.isArray(variants) || !variants.length) return;

      const inventoryAvailabilityNode = productRoot.querySelector('[data-ayv2-inventory-availability]');
      let inventoryAvailability = {};
      try {
        inventoryAvailability = JSON.parse(inventoryAvailabilityNode?.textContent || '{}');
      } catch (_) {
        inventoryAvailability = {};
      }
      variants = variants.map((variant) => ({
        ...variant,
        available: Boolean(variant.available || inventoryAvailability[String(variant.id)])
      }));

      const optionNamesNode = productRoot.querySelector('[data-ayv2-option-names]');
      let optionNames = [];
      try { optionNames = JSON.parse(optionNamesNode?.textContent || '[]'); } catch (_) { optionNames = []; }

      const groups = [...productRoot.querySelectorAll('[data-ayv2-option]')];
      const form = productRoot.querySelector('#AYV2ProductForm');
      const variantInput = productRoot.querySelector('[data-ayv2-variant-input]');
      const quantityInput = productRoot.querySelector('[data-ayv2-quantity]');
      const priceNode = productRoot.querySelector('[data-ayv2-price]');
      const compareNode = productRoot.querySelector('[data-ayv2-compare]');
      const stockNode = productRoot.querySelector('[data-ayv2-stock-status]');
      const messageNode = productRoot.querySelector('[data-ayv2-variant-message]');
      const gallery = productRoot.querySelector('[data-ayv2-gallery]');
      const mainImage = gallery?.querySelector('[data-ayv2-main-image]');
      const currency = productRoot.dataset.currency || 'USD';
      const locale = document.documentElement.lang || 'en-US';
      const selected = groups.map((group) => group.querySelector('[data-ayv2-option-value].is-selected')?.dataset.value || '');
      let currentVariant = variants.find((variant) => String(variant.id) === String(variantInput?.value || '')) || variants[0];
      let purchasePending = false;

      Array.from(document.body.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.nodeValue?.includes('\uFEFF')) {
          node.nodeValue = node.nodeValue.replace(/\uFEFF/g, '');
        }
      });
      document.documentElement.classList.add('ayv2-has-sticky-purchase');
      const inlinePurchase = productRoot.querySelector('.ayv2-pdp__buy');
      const stickyPurchase = productRoot.querySelector('[data-ayv2-sticky-purchase]');
      const stickyTabs = productRoot.querySelector('[data-ayv2-pdp-tabs]');
      let stickyPurchaseFrame = 0;
      let stickyPurchaseVisible = false;
      const setStickyPurchaseVisible = (visible) => {
        if (!stickyPurchase || visible === stickyPurchaseVisible) return;
        stickyPurchaseVisible = visible;
        stickyPurchase.classList.toggle('is-visible', visible);
        stickyPurchase.setAttribute('aria-hidden', visible ? 'false' : 'true');
        document.documentElement.classList.toggle('ayv2-sticky-purchase-visible', visible);
      };
      const updateStickyPurchase = () => {
        if (!inlinePurchase || !stickyPurchase) return;
        const headerBottom = Math.max(0, headerSection?.getBoundingClientRect().bottom || 0);
        const tabsBottom = Math.max(0, stickyTabs?.getBoundingClientRect().bottom || 0);
        const triggerTop = Math.max(headerBottom, tabsBottom);
        const inlineBottom = inlinePurchase.getBoundingClientRect().bottom;
        const shouldShow = stickyPurchaseVisible
          ? inlineBottom <= triggerTop + 20
          : inlineBottom <= triggerTop - 2;
        setStickyPurchaseVisible(shouldShow);
      };
      const scheduleStickyPurchaseUpdate = () => {
        if (stickyPurchaseFrame) return;
        stickyPurchaseFrame = window.requestAnimationFrame(() => {
          stickyPurchaseFrame = 0;
          updateStickyPurchase();
        });
      };
      let previewBarHeight = -1;
      let previewBarSyncTimer = 0;
      let stickyLayoutWidth = document.documentElement.clientWidth;
      const syncPreviewBarOffset = () => {
        const root = document.documentElement;
        const previewBar = document.querySelector('#PBarNextFrameWrapper');
        const previewBarStyle = previewBar ? getComputedStyle(previewBar) : null;
        const previewBarRect = previewBar?.getBoundingClientRect();
        const previewShellPresent = root.classList.contains('shopify-preview-bar-loaded')
          || Boolean(document.querySelector('#preview-bar-iframe, #PBarNextFrame'));
        let nextHeight = 0;

        if (
          previewBar
          && previewBarStyle?.display !== 'none'
          && previewBarStyle?.visibility !== 'hidden'
        ) {
          const measuredHeight = Math.round(previewBarRect?.height || 0);
          if (measuredHeight >= 40) {
            nextHeight = measuredHeight <= 100 ? measuredHeight : 68;
          }
        } else if (!previewBar && previewShellPresent) {
          nextHeight = 68;
        }

        if (nextHeight === previewBarHeight) return;
        previewBarHeight = nextHeight;
        root.style.setProperty('--ayv2-preview-bar-height', `${nextHeight}px`);
        root.classList.toggle('ayv2-preview-bar-visible', nextHeight > 0);
      };
      const schedulePreviewBarSync = (delay = 150) => {
        window.clearTimeout(previewBarSyncTimer);
        previewBarSyncTimer = window.setTimeout(syncPreviewBarOffset, delay);
      };
      syncPreviewBarOffset();
      [300, 1200, 3000].forEach((delay) => window.setTimeout(syncPreviewBarOffset, delay));
      if ('MutationObserver' in window) {
        const previewBarObserver = new MutationObserver((mutations) => {
          const previewClassChanged = mutations.some((mutation) => (
            mutation.type === 'attributes'
            && mutation.target === document.documentElement
            && mutation.attributeName === 'class'
            && String(mutation.oldValue || '').includes('shopify-preview-bar-loaded')
              !== document.documentElement.classList.contains('shopify-preview-bar-loaded')
          ));
          const previewNodeChanged = mutations.some((mutation) => mutation.type === 'childList');
          if (previewClassChanged || previewNodeChanged) schedulePreviewBarSync();
        });
        previewBarObserver.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['class'],
          attributeOldValue: true,
        });
        previewBarObserver.observe(document.body, { childList: true });
      }
      window.addEventListener('scroll', scheduleStickyPurchaseUpdate, { passive: true });
      window.addEventListener('resize', () => {
        const nextLayoutWidth = document.documentElement.clientWidth;
        if (Math.abs(nextLayoutWidth - stickyLayoutWidth) >= 2) {
          stickyLayoutWidth = nextLayoutWidth;
          schedulePreviewBarSync();
        }
        scheduleStickyPurchaseUpdate();
      }, { passive: true });
      if ('ResizeObserver' in window) {
        const stickyPurchaseResizeObserver = new ResizeObserver(scheduleStickyPurchaseUpdate);
        if (inlinePurchase) stickyPurchaseResizeObserver.observe(inlinePurchase);
        if (headerSection) stickyPurchaseResizeObserver.observe(headerSection);
        if (stickyTabs) stickyPurchaseResizeObserver.observe(stickyTabs);
      }
      updateStickyPurchase();

      const formatMoney = (cents) => {
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
        } catch (_) {
          return `${currency} ${((Number(cents) || 0) / 100).toFixed(2)}`;
        }
      };

      const setMessage = (message = '') => {
        if (messageNode) messageNode.textContent = message;
      };

      const actionButtons = () => [
        ...productRoot.querySelectorAll('[data-ayv2-buy-now], [data-ayv2-add], [data-ayv2-sticky-add]')
      ];

      const syncActionButtons = (variant, busy = purchasePending) => {
        const available = Boolean(variant?.available);
        if (stockNode) {
          stockNode.textContent = available ? uiText('In Stock') : uiText('Out of Stock');
          stockNode.classList.toggle('is-in-stock', available);
        }
        actionButtons().forEach((button) => {
          const isBuyNow = button.hasAttribute('data-ayv2-buy-now');
          button.disabled = busy || !available;
          button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
          if (busy) button.textContent = isBuyNow ? uiText('ADDING…') : uiText('ADD TO CART');
          else if (!variant) button.textContent = uiText('UNAVAILABLE');
          else if (!available) button.textContent = uiText('SOLD OUT');
          else button.textContent = isBuyNow ? uiText('BUY NOW') : uiText('ADD TO CART');
        });
      };

      const normalizeMediaPath = (url) => {
        if (!url) return '';
        try {
          return decodeURIComponent(new URL(url, window.location.origin).pathname)
            .replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*|\d*x\d+)(?=\.[a-z0-9]+$)/i, '');
        } catch (_) {
          return String(url).split('?')[0];
        }
      };

      const variantImage = (variant) => {
        const featuredImage = variant?.featured_image;
        const featuredMediaImage = variant?.featured_media?.preview_image;
        if (typeof featuredImage === 'string') return { src: featuredImage, alt: '' };
        return {
          src: featuredMediaImage?.src || featuredMediaImage?.url || featuredImage?.src || featuredImage?.url || '',
          alt: featuredMediaImage?.alt || featuredImage?.alt || ''
        };
      };

      const syncVariantImage = (variant) => {
        const image = variantImage(variant);
        if (!image.src || !gallery) return;

        const targetPath = normalizeMediaPath(image.src);
        let matchedThumb = null;
        gallery?.querySelectorAll('[data-ayv2-thumb]').forEach((thumb) => {
          const active = normalizeMediaPath(thumb.dataset.full) === targetPath;
          thumb.classList.toggle('is-active', active);
          if (active) matchedThumb = thumb;
        });
        if (matchedThumb && typeof gallery?.ayv2SelectMedia === 'function') {
          const matchedIndex = [...gallery.querySelectorAll('[data-ayv2-thumb]')].indexOf(matchedThumb);
          gallery.ayv2SelectMedia(matchedIndex);
          return;
        }

        if (typeof gallery.ayv2ReplaceActiveMedia === 'function') {
          gallery.ayv2ReplaceActiveMedia(image.src, image.alt);
        } else if (mainImage) {
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = image.src;
          if (image.alt) mainImage.alt = image.alt;
        }

        const thumbStrip = matchedThumb?.parentElement;
        if (matchedThumb && thumbStrip) {
          const left = matchedThumb.offsetLeft - (thumbStrip.clientWidth - matchedThumb.clientWidth) / 2;
          thumbStrip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      };

      const syncDiscount = (variant) => {
        if (!gallery) return;
        const price = Number(variant?.price) || 0;
        const compare = Number(variant?.compare_at_price) || 0;
        const percent = compare > price && compare > 0 ? Math.round(((compare - price) / compare) * 100) : 0;
        let badge = gallery.querySelector('.ayv2-pdp__discount');
        if (percent > 0 && !badge) {
          badge = document.createElement('span');
          badge.className = 'ayv2-pdp__discount';
          gallery.prepend(badge);
        }
        if (!badge) return;
        badge.hidden = percent < 1;
        badge.textContent = percent > 0 ? `${percent}% ${uiLocale === 'de' ? 'RABATT' : uiLocale === 'es' ? 'DE DESCUENTO' : 'OFF'}` : '';
      };

      const syncVariantUrl = (variant) => {
        if (!variant?.id || !window.history?.replaceState) return;
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({ ...(window.history.state || {}), ayv2Variant: variant.id }, '', url);
        } catch (_) {
          /* Keep selection functional if the URL cannot be updated. */
        }
      };

      const syncModalSelections = () => {
        let capSize = uiText('Selected option');
        let laceTone = uiText('Selected option');
        selected.forEach((value, index) => {
          const name = String(optionNames[index] || groups[index]?.dataset.optionName || '').toLowerCase();
          if (name.includes('lace')) laceTone = value || laceTone;
          else if (name.includes('cap') || (name.includes('size') && !name.includes('length'))) capSize = value || capSize;
        });

        document.querySelectorAll('template[data-ayv2-modal-template="details"]').forEach((template) => {
          const capNode = template.content?.querySelector('[data-ayv2-selected-cap]');
          const laceNode = template.content?.querySelector('[data-ayv2-selected-lace]');
          if (capNode) capNode.textContent = uiOption("Cap Size", capSize);
          if (laceNode) laceNode.textContent = uiOption("Lace Tone", laceTone);
        });
        contentModalRoot?.querySelectorAll('[data-ayv2-selected-cap]').forEach((node) => { node.textContent = uiOption("Cap Size", capSize); });
        contentModalRoot?.querySelectorAll('[data-ayv2-selected-lace]').forEach((node) => { node.textContent = uiOption("Lace Tone", laceTone); });
      };

      const syncOptionButtons = () => {
        groups.forEach((group, index) => {
          group.querySelectorAll('[data-ayv2-option-value]').forEach((button) => {
            const value = button.dataset.value || '';
            const selectedHere = selected[index] === value;
            const anyWithValue = variants.some((variant) => variant.options?.[index] === value);
            const matchingCurrent = variants.filter((variant) => (
              variant.options?.[index] === value
              && selected.every((selectedValue, optionIndex) => optionIndex === index || !selectedValue || variant.options?.[optionIndex] === selectedValue)
            ));
            button.disabled = !anyWithValue;
            button.classList.toggle('is-selected', selectedHere);
            button.classList.toggle('is-unavailable', anyWithValue && matchingCurrent.length === 0);
            button.classList.toggle('is-sold-out', matchingCurrent.length > 0 && !matchingCurrent.some((variant) => variant.available));
            button.setAttribute('aria-pressed', selectedHere ? 'true' : 'false');
            button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
          });
        });
      };

      const renderVariant = (variant, { updateUrl = true, updateImage = true } = {}) => {
        currentVariant = variant || null;
        if (variantInput) variantInput.value = variant?.id || '';
        if (priceNode && variant) priceNode.textContent = formatMoney(variant.price);

        const compare = Number(variant?.compare_at_price) || 0;
        const price = Number(variant?.price) || 0;
        if (compareNode) {
          const showCompare = Boolean(variant && compare > price);
          compareNode.textContent = showCompare ? formatMoney(compare) : '';
          compareNode.hidden = !showCompare;
        }

        syncActionButtons(variant);
        syncDiscount(variant);
        syncOptionButtons();
        syncModalSelections();
        if (variant && updateImage) syncVariantImage(variant);
        if (variant && updateUrl) syncVariantUrl(variant);

        if (!variant) setMessage(uiText('This option combination is unavailable. Please choose another option.'));
        else if (!variant.available) setMessage(uiText('This selection is currently sold out.'));
        else setMessage('');

        if (variant) {
          productRoot.dispatchEvent(new CustomEvent('ayv2:variant-change', {
            bubbles: true,
            detail: { variant }
          }));
        }
      };

      const findSelectedVariant = () => variants.find((variant) => (
        variant.options?.every((value, index) => value === selected[index])
      ));

      groups.forEach((group, index) => {
        group.querySelectorAll('[data-ayv2-option-value]').forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            const previous = selected.slice();
            selected[index] = button.dataset.value || '';
            let variant = findSelectedVariant();

            if (!variant) {
              const candidates = variants
                .filter((item) => item.options?.[index] === selected[index])
                .map((item) => ({
                  item,
                  score: item.options.reduce((total, value, optionIndex) => (
                    total + (optionIndex !== index && value === previous[optionIndex] ? 1 : 0)
                  ), 0)
                }))
                .sort((a, b) => b.score - a.score || Number(b.item.available) - Number(a.item.available));
              variant = candidates[0]?.item || null;
              if (variant) variant.options.forEach((value, optionIndex) => { selected[optionIndex] = value; });
            }

            renderVariant(variant);
          });
        });
      });

      if (currentVariant?.options?.length) {
        currentVariant.options.forEach((value, index) => { selected[index] = value; });
      }
      renderVariant(currentVariant, { updateUrl: false, updateImage: false });

      const readQuantity = () => {
        if (!quantityInput) return 1;
        const minimum = Math.max(1, Number.parseInt(quantityInput.min || '1', 10) || 1);
        const maximum = Number.parseInt(quantityInput.max || '', 10);
        let quantity = Number.parseInt(quantityInput.value, 10);
        if (!Number.isFinite(quantity)) quantity = minimum;
        quantity = Math.max(minimum, quantity);
        if (Number.isFinite(maximum)) quantity = Math.min(maximum, quantity);
        quantityInput.value = String(quantity);
        return quantity;
      };

      quantityInput?.addEventListener('change', readQuantity);
      quantityInput?.addEventListener('blur', readQuantity);

      form?.addEventListener('submit', (event) => {
        if (purchasePending) {
          event.preventDefault();
          return;
        }
        readQuantity();
        if (currentVariant?.available && variantInput?.value) return;
        event.preventDefault();
        setMessage(currentVariant ? uiText('This selection is currently sold out.') : uiText('Please choose an available option combination.'));
      });

      productRoot.querySelector('[data-ayv2-sticky-add]')?.addEventListener('click', () => {
        if (purchasePending || !form || !currentVariant?.available) return;
        const submitButton = form.querySelector('[data-ayv2-add]');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submitButton || undefined);
        else submitButton?.click();
      });

      productRoot.querySelectorAll('[data-ayv2-buy-now]').forEach((button) => {
        button.addEventListener('click', async () => {
          if (purchasePending) return;
          if (!form || !currentVariant?.available || !variantInput?.value) {
            setMessage(uiText('Please choose an available option before checking out.'));
            return;
          }

          const rawAddUrl = productRoot.dataset.cartAddUrl || '/cart/add';
          const addUrl = /\.js(?:\?|$)/.test(rawAddUrl) ? rawAddUrl : `${rawAddUrl.replace(/\/$/, '')}.js`;
          const formData = new FormData(form);
          formData.set('id', String(currentVariant.id));
          formData.set('quantity', String(readQuantity()));
          formData.delete('add');
          purchasePending = true;
          syncActionButtons(currentVariant);
          setMessage('');

          try {
            const response = await fetch(addUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            });
            const payload = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(payload.description || payload.message || uiText('Unable to add this item.'));
            window.location.assign(productRoot.dataset.checkoutUrl || '/checkout');
          } catch (error) {
            purchasePending = false;
            syncActionButtons(currentVariant);
            const message = error?.message || uiText('Unable to add this item. Please try again.');
            setMessage(message);
            showToast(message);
          }
        });
      });

      const reviewsSection = productRoot.querySelector('.ayv2-pdp-reviews');
      const reviewAppBlocks = [...(reviewsSection?.querySelectorAll('.ayv2-review-app') || [])];
      if (reviewsSection && reviewAppBlocks.length) {
        let reviewWaitExpired = false;
        let reviewWaitTimer = null;
        const syncReviewEmptyState = () => {
          const widget = reviewsSection.querySelector('.jdgm-review-widget');
          const expectedCount = Number(reviewsSection.dataset.reviewCount || 0);
          const hasReviewContent = Boolean(widget?.querySelector('.jdgm-rev'));
          const confirmedEmpty = expectedCount === 0 && widget?.getAttribute('data-number-of-reviews') === '0'
            && Boolean(widget.querySelector('.jdgm-rev-widg__summary-text, .jdgm-rev-widg__body'));
          let fallback = reviewsSection.querySelector('[data-ayv2-generated-review-empty]');
          if (hasReviewContent || confirmedEmpty) {
            if (reviewWaitTimer) window.clearTimeout(reviewWaitTimer);
            fallback?.remove();
            return;
          }
          if (!fallback) {
            fallback = document.createElement('div');
            fallback.className = 'ayv2-pdp-reviews__empty';
            fallback.dataset.ayv2GeneratedReviewEmpty = 'true';
            fallback.setAttribute('role', 'status');
            fallback.setAttribute('aria-live', 'polite');
            reviewsSection.appendChild(fallback);
          }
          fallback.textContent = reviewWaitExpired
            ? uiText('Reviews could not be loaded. Please refresh the page to try again.')
            : uiText('Loading customer reviews…');
        };
        const reviewObserver = new MutationObserver(syncReviewEmptyState);
        reviewAppBlocks.forEach((block) => reviewObserver.observe(block, { childList: true, subtree: true, characterData: true }));
        const startReviewWait = () => {
          if (reviewWaitTimer || reviewsSection.querySelector('.jdgm-rev')) return;
          reviewWaitTimer = window.setTimeout(() => { reviewWaitExpired = true; syncReviewEmptyState(); }, 30000);
        };
        if ('IntersectionObserver' in window) {
          const reviewVisibility = new IntersectionObserver((entries) => {
            if (entries.some(entry => entry.isIntersecting)) { startReviewWait(); reviewVisibility.disconnect(); }
          }, { rootMargin: '300px' });
          reviewVisibility.observe(reviewsSection);
        } else startReviewWait();
        syncReviewEmptyState();
      }

      const recommendationRoot = productRoot.querySelector('product-recommendations.ayv2-recommendations');
      if (recommendationRoot) {
        const syncRecommendations = () => {
          recommendationRoot.classList.toggle('is-ready', Boolean(
            recommendationRoot.querySelector('h2') && recommendationRoot.querySelector('.ayv2-product-grid')
          ));
        };
        new MutationObserver(syncRecommendations).observe(recommendationRoot, { childList: true, subtree: true });
        syncRecommendations();
      }

      const tabs = productRoot.querySelector('[data-ayv2-pdp-tabs]');
      const overview = productRoot.querySelector('#ayv2-overview');
      const reviews = productRoot.querySelector('#ayv2-reviews');
      if (tabs && overview && reviews) {
        const tabLinks = [...tabs.querySelectorAll('[data-ayv2-tab]')];
        const headerBottom = () => Math.max(0, Math.round(headerSection?.getBoundingClientRect().bottom || 0));
        const setActiveTab = (name) => {
          tabLinks.forEach((link) => {
            const active = link.dataset.ayv2Tab === name;
            link.classList.toggle('is-active', active);
            if (active) link.setAttribute('aria-current', 'page');
            else link.removeAttribute('aria-current');
          });
        };
        const updateTabs = () => {
          const top = headerBottom();
          productRoot.style.setProperty('--ayv2-pdp-tabs-top', `${top}px`);
          const threshold = top + tabs.offsetHeight + 24;
          setActiveTab(reviews.getBoundingClientRect().top <= threshold ? 'reviews' : 'overview');
        };
        let tabFrame = 0;
        const scheduleTabUpdate = () => {
          if (tabFrame) return;
          tabFrame = window.requestAnimationFrame(() => {
            tabFrame = 0;
            updateTabs();
          });
        };

        tabLinks.forEach((link) => {
          link.addEventListener('click', (event) => {
            const target = link.dataset.ayv2Tab === 'reviews' ? reviews : overview;
            if (!target) return;
            event.preventDefault();
            const offset = headerBottom() + tabs.offsetHeight + 8;
            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({
              top: Math.max(0, top),
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
            setActiveTab(link.dataset.ayv2Tab);
          });
        });
        window.addEventListener('scroll', scheduleTabUpdate, { passive: true });
        window.addEventListener('resize', scheduleTabUpdate, { passive: true });
        if ('ResizeObserver' in window) {
          const tabResizeObserver = new ResizeObserver(scheduleTabUpdate);
          tabResizeObserver.observe(tabs);
          if (headerSection) tabResizeObserver.observe(headerSection);
        }
        updateTabs();
      }
    });
  });
})();

(() => {
  const STORY_ROOT = '[data-ayv2-story-v2]';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

  const initStoryReveal = (root) => {
    const items = [...root.querySelectorAll('.ayv2-reveal:not(.is-visible)')];
    if (!items.length) return;
    if (reducedMotion() || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, revealObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((item) => observer.observe(item));
  };

  const initStorySlider = (slider) => {
    if (!slider || slider.dataset.ayv2StorySliderReady === 'true') return;
    slider.dataset.ayv2StorySliderReady = 'true';

    const track = slider.querySelector('[data-ayv2-story-slider-track]');
    const cards = [...slider.querySelectorAll('[data-ayv2-story-slide]')];
    const dots = [...slider.querySelectorAll('[data-ayv2-story-slider-dot]')];
    const previous = slider.querySelector('[data-ayv2-story-slider-prev]');
    const next = slider.querySelector('[data-ayv2-story-slider-next]');
    if (!track || !cards.length) return;

    let activeIndex = 0;
    let scrollTimer = 0;
    const cardLeft = (card) => card.offsetLeft - cards[0].offsetLeft;
    const render = () => {
      dots.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const findActive = () => {
      let closestIndex = 0;
      let closestDistance = Infinity;
      cards.forEach((card, index) => {
        const distance = Math.abs(cardLeft(card) - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      activeIndex = closestIndex;
      render();
    };
    const select = (index, behavior = reducedMotion() ? 'auto' : 'smooth') => {
      activeIndex = (index + cards.length) % cards.length;
      track.scrollTo({ left: Math.max(0, cardLeft(cards[activeIndex])), behavior });
      render();
    };

    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(findActive, 80);
    }, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      select(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    previous?.addEventListener('click', () => select(activeIndex - 1));
    next?.addEventListener('click', () => select(activeIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => select(index)));
    render();
  };

  const initStoryTimeline = (timeline) => {
    if (!timeline || timeline.dataset.ayv2StoryTimelineReady === 'true') return;
    timeline.dataset.ayv2StoryTimelineReady = 'true';

    const stages = [...timeline.querySelectorAll('[data-ayv2-story-stage]')];
    if (!stages.length) return;
    let frame = 0;
    const update = () => {
      frame = 0;
      const timelineRect = timeline.getBoundingClientRect();
      const firstPoint = stages[0].offsetTop + 11;
      const lastPoint = stages[stages.length - 1].offsetTop + 11;
      const cursor = clamp(window.innerHeight * 0.56 - timelineRect.top, firstPoint, lastPoint);
      const denominator = Math.max(1, lastPoint - firstPoint);
      const progress = clamp(((cursor - firstPoint) / denominator) * 100, 0, 100);
      timeline.style.setProperty('--ayv2-sv2-timeline-progress', `${progress}%`);

      let currentIndex = 0;
      stages.forEach((stage, index) => {
        if (cursor >= stage.offsetTop) currentIndex = index;
      });
      if (timelineRect.bottom <= window.innerHeight * 0.56) currentIndex = stages.length - 1;
      stages.forEach((stage, index) => {
        stage.classList.toggle('is-current', index === currentIndex);
        stage.classList.toggle('is-passed', index < currentIndex);
      });
    };
    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(timeline);
    update();
  };

  const selectStoryHotspot = (button) => {
    const region = button?.closest('[data-ayv2-story-hotspot-region]');
    const card = region?.querySelector('[data-ayv2-story-hotspot-card]');
    if (!button || !region || !card) return;

    region.querySelectorAll('[data-ayv2-story-hotspot]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-expanded', active ? 'true' : 'false');
    });
    const number = card.querySelector('[data-ayv2-story-hotspot-number]');
    const title = card.querySelector('[data-ayv2-story-hotspot-title]');
    const copy = card.querySelector('[data-ayv2-story-hotspot-copy]');
    if (number) number.textContent = button.dataset.number || '';
    if (title) title.textContent = button.dataset.title || '';
    if (copy) copy.textContent = button.dataset.copy || '';
  };

  const initStoryHotspots = (root) => {
    root.querySelectorAll('[data-ayv2-story-hotspot]').forEach((button) => {
      if (button.dataset.ayv2StoryHotspotReady === 'true') return;
      button.dataset.ayv2StoryHotspotReady = 'true';
      button.addEventListener('click', () => selectStoryHotspot(button));
    });
  };

  const initStory = (root) => {
    if (!root || root.dataset.ayv2StoryV2Ready === 'true') return;
    root.dataset.ayv2StoryV2Ready = 'true';
    initStoryReveal(root);
    root.querySelectorAll('[data-ayv2-story-slider]').forEach(initStorySlider);
    root.querySelectorAll('[data-ayv2-story-timeline]').forEach(initStoryTimeline);
    initStoryHotspots(root);
  };

  const initStoryScope = (scope = document) => {
    if (scope.matches?.(STORY_ROOT)) initStory(scope);
    scope.querySelectorAll?.(STORY_ROOT).forEach(initStory);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initStoryScope(), { once: true });
  } else {
    initStoryScope();
  }

  document.addEventListener('shopify:section:load', (event) => initStoryScope(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest?.(STORY_ROOT);
    if (!root) return;
    const hotspot = event.target.closest?.('[data-ayv2-story-hotspot]');
    if (hotspot) selectStoryHotspot(hotspot);
    event.target.classList.add('is-visible');
    event.target.scrollIntoView({
      block: 'center',
      behavior: reducedMotion() ? 'auto' : 'smooth'
    });
  });
})();

/* Product suggestions use Shopify's locale-aware predictive search endpoint. */
(() => {
  const form = document.querySelector('.ayv2-search-form');
  const input = form?.querySelector('input[name="q"]');
  if (!input) return;
  const lang = document.documentElement.lang.split('-')[0];
  const words = {
    en: { title: 'Suggested products', loading: 'Searching…', empty: 'No product suggestions. Press Enter to search the store.', failed: 'Suggestions are unavailable. Press Enter to search the store.', all: 'View all results', sold: 'Sold out' },
    de: { title: 'Produktvorschläge', loading: 'Suche läuft …', empty: 'Keine Produktvorschläge. Drücke Enter, um den Shop zu durchsuchen.', failed: 'Vorschläge sind nicht verfügbar. Drücke Enter, um den Shop zu durchsuchen.', all: 'Alle Ergebnisse ansehen', sold: 'Ausverkauft' },
    es: { title: 'Productos sugeridos', loading: 'Buscando…', empty: 'No hay sugerencias de productos. Pulsa Enter para buscar en la tienda.', failed: 'Las sugerencias no están disponibles. Pulsa Enter para buscar en la tienda.', all: 'Ver todos los resultados', sold: 'Agotado' }
  };
  const w = words[lang] || words.en;
  const region = document.createElement('div'); region.className = 'ayv2-predictive'; region.id = 'AYV2PredictiveResults'; region.hidden = true;
  const status = document.createElement('p'); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
  const nav = document.createElement('nav'); nav.setAttribute('aria-label', w.title);
  region.append(status, nav); form.after(region); input.setAttribute('aria-controls', region.id); input.autocomplete = 'off';
  let timer, controller, generation = 0;
  const queryUrl = term => { const url = new URL(form.action); url.searchParams.set('q', term); return url; };
  async function suggest() {
    const term = input.value.trim(); const ticket = ++generation; controller?.abort(); nav.replaceChildren();
    if (!term) { region.hidden = true; return; }
    region.hidden = false; status.textContent = w.loading;
    const url = queryUrl(term); url.pathname = url.pathname.replace(/\/$/, '') + '/suggest.json';
    url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '6');
    controller = new AbortController();
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Predictive search unavailable');
      const payload = await response.json(); if (ticket !== generation) return;
      const products = payload.resources?.results?.products;
      if (!Array.isArray(products)) throw new Error('Unexpected predictive response');
      status.textContent = products.length ? w.title : w.empty;
      products.forEach(product => {
        const target = new URL(product.url, location.origin);
        if (target.origin !== location.origin || !target.pathname.includes('/products/')) return;
        const link = document.createElement('a'); link.href = target.href; link.dataset.productId = String(product.id); link.dataset.available = String(product.available);
        const title = document.createElement('span'); title.textContent = product.title; link.append(title);
        if (!product.available) { const sold = document.createElement('small'); sold.textContent = w.sold; link.append(sold); }
        nav.append(link);
      });
      const all = document.createElement('a'); all.href = queryUrl(term).href; all.textContent = w.all; all.className = 'ayv2-predictive__all'; nav.append(all);
    } catch (error) {
      if (ticket !== generation || error.name === 'AbortError') return;
      status.textContent = w.failed;
    }
  }
  input.addEventListener('input', () => { clearTimeout(timer); controller?.abort(); generation++; timer = setTimeout(suggest, 300); });
  input.addEventListener('focus', () => { if (input.value.trim() && region.hidden) suggest(); });
  input.addEventListener('keydown', event => { if (event.key === 'ArrowDown' && nav.querySelector('a')) { event.preventDefault(); nav.querySelector('a').focus(); } });
  nav.addEventListener('keydown', event => {
    if (!['ArrowDown','ArrowUp'].includes(event.key)) return;
    const links = Array.from(nav.querySelectorAll('a')); const index = links.indexOf(document.activeElement); if (index < 0) return;
    event.preventDefault(); const next = index + (event.key === 'ArrowDown' ? 1 : -1); (links[next] || input).focus();
  });
})();
